<template>
    <div class="game-intro-page">
        <div class="lf-sec">
            <div class="swiper-section">
                <template v-if="bigImgs.length">
                    <swiper :options="swiperOption" @slideChangeTransitionStart="slideChangeTransitionStart">
                        <swiper-slide v-for="item in bigImgs" :key="item.id" class="swiper-no-swiping">
                            <div class="swiper-img">
                                <lazy-image v-if="item.src" :src="item.src"></lazy-image>
                            </div>
                        </swiper-slide>
                    </swiper>
                </template>
            </div>
            <div class="small-img-sec">
                <div class="arr-btn">
                    <div class="inner" :class="{ 'not-click': smallImgs.length < 2 }" @click="changeSwiper('left')"></div>
                </div>
                <div class="center">
                    <template v-if="smallImgs.length">
                        <swiper :options="swiperOption1">
                            <swiper-slide v-for="(item, index) in smallImgs" :key="item.id">
                                <div class="img-wrap">
                                    <lazy-image :src="item.src" :style="{ 'border-radius': '0.625rem' }" @click="() => changeSwiper(index)"></lazy-image>
                                </div>
                                <div class="cover-img" v-if="activeIndex == index"></div>
                            </swiper-slide>
                        </swiper>
                    </template>
                </div>
                <div class="arr-btn">
                    <div class="inner rg-inner" :class="{ 'not-click': smallImgs.length < 2 }" @click="changeSwiper('right')"></div>
                </div>
            </div>
            <div class="game-intro" v-html="gameInfo.introduce"></div>
        </div>
        <div class="rg-sec">
            <!-- <div class="sale-goods-wrap" v-if="rightGoodsList.length">
                <SaleGoodsItem class="item" v-for="(item, index) in rightGoodsList" :key="`${item.id}-${index}`" :sale-goods="item" :wx-info="wxInfo" :zfb-info="zfbInfo"></SaleGoodsItem>
            </div> -->
            <div class="low-disp module-info">
                <div class="title">最低配置</div>
                <div class="item-wrap">
                    <div class="item" v-for="(item, index) in lowSysreq" :key="index">
                        <div class="item-title">{{ item.key }}</div>
                        <div class="item-con">{{ item.value }}</div>
                    </div>
                </div>
            </div>
            <div class="game-info module-info">
                <div class="title">游戏信息</div>
                <div class="item-wrap">
                    <div class="item">
                        <div class="item-title">开发商</div>
                        <div class="item-con">{{ gameInfo.developer }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">发行时间</div>
                        <div class="item-con">{{ gameInfo.release_date }}</div>
                    </div>
                    <div class="item">
                        <div class="item-title">游戏语言</div>
                        <div class="item-con">{{ gameInfo.language_support }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SaleGoodsItem from '../subComp/SaleGoodsItem.vue'
import { getGoodsSp, getSpInfo } from '@/http/api/goods'
import { getPayConfig } from '@/http/api/vip'
import { getCookieToken } from '@/utils/auth'

export default {
    name: 'GameIntroPage',
    components: { SaleGoodsItem },
    props: {
        gameInfo: {
            type: Object,
            default: () => ({})
        },
        goodsId: {
            type: Number,
            default: 0
        }
    },
    data() {
        const that = this
        return {
            activeIndex: 0,
            swiperOption: {
                initialSlide: 0,
                touchMove: false,
                loop: false,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false
                },
                on: {
                    init: function() {
                        that.bigSwiperInstance = this
                    }
                }
            },
            swiperOption1: {
                initialSlide: 0,
                slidesPerView: 'auto',
                on: {
                    init: function() {
                        that.smallSwiperInstance = this
                    }
                }
            },
            goodsInfo: {}, // 游戏商品详情
            bigImgs: [],
            smallImgs: [],
            lowSysreq: [],
            spList: [], // 商品规格列表
            rightGoodsList: [], // 右侧独享账号和开启了游戏单独售卖
            relationIds: [], // 独享账号关联的商城商品id
            wxInfo: {},
            zfbInfo: {}
        }
    },
    watch: {
        gameInfo(cur) {
            if (JSON.stringify(cur) != '{}') {
                this.resetData()
                this.formatSysreq(cur.sysreq)
                this.formatImgs(cur.screenshot_list)
                this.getGoodsSp()
            }
        }
    },
    mounted() {
        this.getPayConfigData()
        if (this.gameInfo.game_id) {
            this.resetData()
            this.formatSysreq(this.gameInfo.sysreq)
            this.formatImgs(this.gameInfo.screenshot_list)
            this.getGoodsSp()
        }
    },
    methods: {
        filterImg(value, w_h) {
            return this.$Utils.filterImgUrl(value, w_h)
        },
        slideChangeTransitionStart() {
            this.activeIndex = this.bigSwiperInstance.realIndex
            this.smallSwiperInstance.slideTo(this.bigSwiperInstance.realIndex, 500, false)
        },
        resetData() {
            this.bigSwiperInstance && this.bigSwiperInstance.destroy()
            this.smallSwiperInstance && this.smallSwiperInstance.destroy()
            this.bigImgs = []
            this.smallImgs = []
            this.lowSysreq = []
            this.spList = []
            this.rightGoodsList = []
            this.relationIds = []
            this.activeIndex = 0
        },
        changeSwiper(params) {
            if (this.smallImgs.length < 2) {
                return false
            }

            if (params === 'left') {
                this.bigSwiperInstance.slidePrev()
            } else if (params === 'right') {
                this.bigSwiperInstance.slideNext()
            } else if (!isNaN(parseInt(params))) {
                this.bigSwiperInstance.slideToLoop(params, 500, false)
            }

            this.activeIndex = this.bigSwiperInstance.realIndex
            this.smallSwiperInstance.slideTo(this.bigSwiperInstance.realIndex, 500, false)
        },
        formatSysreq(value) {
            try {
                let tempValue = JSON.parse(value),
                    tempArr = []

                tempValue.forEach(v => {
                    let key = Object.keys(v)[0]
                    tempArr.push({ key, value: v[key] })
                })

                this.lowSysreq = tempArr
            } catch (error) {}
        },
        formatImgs(value) {
            this.$nextTick(() => {
                if (Array.isArray(value)) {
                    for (let i = 0; i < value.length; i++) {
                        let v = value[i]
                        this.bigImgs.push({ id: v.id, src: this.filterImg(v.url, '870x489') })
                        this.smallImgs.push({ id: v.id, src: this.filterImg(v.thumbnail, '155x87') })

                        if (value.length == 1) {
                            this.swiperOption.autoplay = false
                        } else {
                            this.swiperOption.autoplay = {
                                delay: 5000,
                                disableOnInteraction: false
                            }
                        }
                    }
                }
            })
        },
        getGoodsSp() {
            const query = {
                page: 1,
                size: 20,
                gid: this.goodsId
            }

            if (query.gid) {
                getGoodsSp(query).then(res => {
                    if (res.code == 200 && Array.isArray(res.data.list)) {
                        this.spList = res.data.list
                        this.goodsInfo = res.data.goods_info

                        for (let i = 0; i < this.spList.length; i++) {
                            let v = this.spList[i]

                            if (v.mode == 1 && v.is_sell == 1) {
                                this.rightGoodsList.push({ ...v, name: this.goodsInfo.name, img: this.gameInfo.icon })
                            } else if (v.mode == 3) {
                                this.relationIds.push(v.relation_id)
                                this.rightGoodsList.push({ ...v, name: '', img: '', shop_goods_id: 0 })
                            }
                        }

                        this.getGoodsDetailBySid()
                        this.$emit('get-goods', { spList: this.spList, goodsInfo: this.goodsInfo })
                    }
                })
            }
        },
        // 通过规格id，获取商品详情
        getGoodsDetailBySid() {
            const query = { sids: JSON.stringify(this.relationIds) }
            getSpInfo(query).then(res => {
                if (res.code == 200 && Array.isArray(res.data.goodsSpecification)) {
                    let list = res.data.goodsSpecification
                    list.forEach(v => {
                        let shopGoodsSpInfo = this.rightGoodsList.find(v1 => v1.relation_id == v.id)
                        if (shopGoodsSpInfo) {
                            shopGoodsSpInfo.name = v.goodName
                            shopGoodsSpInfo.shop_goods_id = v.gid
                            try {
                                shopGoodsSpInfo.img = JSON.parse(v.goodsImgs)[0]
                            } catch (error) {}
                        }
                    })
                }
            })
        },
        getPayConfigData() {
            if (!getCookieToken()) {
                // 是否登录
                return false
            }
            getPayConfig({ orderPrefix: 'ALL' })
                .then(res => {
                    if (res.code == 200 && this.$Utils.isObject(res.data)) {
                        if (Array.isArray(res.data.list) && res.data.list.length) {
                            res.data.list.forEach(v => {
                                if (v.is_enable == 1 && v.pay_channel == 'WEIXIN') {
                                    this.wxInfo = { ...v }
                                }
                                if (v.is_enable == 1 && v.pay_channel == 'ALIPAY') {
                                    this.zfbInfo = { ...v }
                                }
                            })
                        }
                    }
                })
                .catch(err => {})
        }
    }
}
</script>
<style lang="less" scoped>
.game-intro-page {
    display: flex;

    .lf-sec {
        width: 870px;
        flex-shrink: 0;
        margin-right: 20px;

        .swiper-section {
            height: 489px;

            /deep/ .swiper-container {
                width: 100%;
                height: 100%;
                border-radius: 10px;

                .swiper-slide {
                    height: 489px;

                    .swiper-img {
                        height: 489px;

                        img {
                            display: block;
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }
                    }
                }
            }
        }

        .small-img-sec {
            margin-top: 1px;
            display: flex;
            height: 96px;

            .arr-btn {
                padding-top: 9px;

                .inner {
                    height: 87px;
                    cursor: pointer;
                    width: 28px;
                    flex-shrink: 0;
                    background-image: url(../../../assets/arrow_back.png);
                    background-size: 10px 16px;
                    background-position: center;
                    background-repeat: no-repeat;

                    &:hover {
                        background-image: url(../../../assets/arrow_back_1.png);
                    }

                    &.not-click {
                        cursor: not-allowed;
                    }

                    &.rg-inner {
                        transform: rotateZ(180deg);
                    }
                }
            }

            .center {
                width: 814px;

                /deep/ .swiper-container {
                    width: 100%;
                    height: 100%;

                    .swiper-slide {
                        width: 165px;
                        height: 96px;
                        padding-top: 9px;
                        position: relative;

                        .img-wrap {
                            width: 155px;
                            height: 87px;
                        }

                        .cover-img {
                            top: 0;
                            left: 0;
                            width: 155px;
                            height: 96px;
                            position: absolute;
                            background: url(../../../assets/swiper-active.png) center/100% no-repeat;
                        }
                    }
                }
            }
        }

        .game-intro {
            margin-top: 40px;
            padding-bottom: 10px;
            color: @color-txt-normal !important;
            line-height: 1.5;

            /deep/ p,
            /deep/ b,
            /deep/ i,
            /deep/ s,
            /deep/ em,
            /deep/ a,
            /deep/ font,
            /deep/ span,
            /deep/ ul,
            /deep/ li,
            /deep/ table,
            /deep/ tr,
            /deep/ td,
            /deep/ button,
            /deep/ input,
            /deep/ select,
            /deep/ textarea,
            /deep/ form {
                color: @color-txt-normal !important;
            }

            /deep/ h1,
            /deep/ h2,
            /deep/ h3,
            /deep/ h4,
            /deep/ h5,
            /deep/ h6,
            /deep/ strong {
                color: #fff !important;
            }

            /deep/ img,
            /deep/ audio,
            /deep/ video {
                max-width: 100%;
            }
        }
    }

    .rg-sec {
        flex: 1;

        .sale-goods-wrap {
            margin-bottom: 20px;

            .item {
                margin-bottom: 20px;

                &:last-child {
                    margin-bottom: 0;
                }
            }
        }

        .module-info {
            border-radius: 10px;
            padding: 20px;
            background: @bg-color-1E;

            .title {
                font-size: 16px;
                line-height: 16px;
                margin-bottom: 30px;
            }

            .item-wrap {
                .item {
                    display: flex;
                    font-size: 14px;
                    line-height: 18px;
                    margin-bottom: 18px;

                    .item-title {
                        width: 60px;
                        flex-shrink: 0;
                        margin-right: 8px;
                        color: @color-txt-normal;
                    }

                    .item-con {
                        flex: 1;
                        color: @bg-color-cc;
                    }

                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            }
        }

        .low-disp {
            margin-bottom: 20px;
        }
    }
}
</style>
